import Component from 'flarum/common/Component';
import ItemList from 'flarum/common/utils/ItemList';
import { debounce } from 'flarum/common/utils/throttleDebounce';
import app from 'flarum/forum/app';
import MobileTabItemsRegistryForum from '../data/MobileTabItemsRegistryForum';
import MobileTabItem from './MobileTabItem';
export default class MobileTab extends Component {
  lastScrollTop = 0;
  scrollThreshold = app.forum.attribute('acplMobileTabScrollThreshold') ?? 80;
  isHidden = false;
  oncreate(vnode) {
    super.oncreate(vnode);
    if (app.forum.attribute('acplMobileTabHideOnScroll') ?? true) {
      addEventListener('scroll', this.handleScroll, {
        passive: true
      });
    }
  }
  onremove(vnode) {
    super.onremove(vnode);
    removeEventListener('scroll', this.handleScroll);
  }
  view(vnode) {
    return m("nav", {
      className: "MobileTab"
    }, m("ul", {
      className: "MobileTab-items"
    }, this.items().toArray().filter(({
      canView
    }) => typeof canView === 'function' ? canView() : canView ?? true).map(item => m("li", {
      key: item.itemName
    }, item.forumComponent ? m(item.forumComponent, {
      definition: item
    }) : m(MobileTabItem, {
      href: typeof item.href === 'function' ? item.href() : item.href,
      icon: item.icon,
      target: item.isNewTab ? '_blank' : undefined,
      external: item.isInternal === undefined ? false : !item.isInternal,
      counter: item.counter?.()
    }, item.label)))));
  }
  items() {
    const registeredItems = new MobileTabItemsRegistryForum().items();
    const settings = app.forum.attribute('acplMobileTabItems');
    const items = new ItemList();
    settings.forEach(item => {
      if (registeredItems.has(item)) {
        items.add(item, registeredItems.get(item));
      }
    });
    return items;
  }
  show = () => {
    if (!this.isHidden) return;
    this.element.classList.remove('MobileTab--hidden');
    this.element.removeAttribute('inert');
    this.isHidden = false;
  };
  hide = () => {
    if (this.isHidden) return;
    this.element.classList.add('MobileTab--hidden');
    this.element.setAttribute('inert', '');
    this.isHidden = true;
  };
  handleScroll = event => {
    const scrollTop = window.scrollY;
    this.resetScrollReference();
    if (scrollTop <= 0) {
      this.show();
      this.lastScrollTop = 0;
      return;
    }

    // Ignore small movements
    if (Math.abs(scrollTop - this.lastScrollTop) < this.scrollThreshold) {
      return;
    }
    if (scrollTop > this.lastScrollTop) {
      this.hide();
    } else {
      this.show();
    }
    this.lastScrollTop = scrollTop;
  };

  /**
   * Reset the reference point when scrolling stops.
   * This prevents small, accumulated deltas from triggering visibility changes immediately after the user pauses and resumes scrolling.
   */
  resetScrollReference = debounce(150, () => {
    this.lastScrollTop = window.scrollY;
  });
}
flarum.reg.add('acpl-mobile-tab', 'forum/components/MobileTab', MobileTab);